import { BulkActionEntryData } from "@/common/types/bulkActions/entry.type";
import ResumeBox from "../../ResumeBox";
import { formatDateTime, formatDecimal } from "@/common/utils/formatters";

interface BulkActionEntryResultDataProps {
  entry: BulkActionEntryData;
}

export const BulkActionEntryResultData = ({ entry }: BulkActionEntryResultDataProps) => {

  if (entry.status === 'generating_template') {
    return null;
  }

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center gap-2">
        <ResumeBox
          boxClassName="w-1/4"
          label="Começou em"
          value={entry.result_data?.started_at ? formatDateTime(new Date(entry.result_data.started_at)) : '--'}
        />

        <ResumeBox
          boxClassName="w-1/4"
          label="Terminou em"
          value={entry.result_data?.ended_at ? formatDateTime(new Date(entry.result_data.ended_at)) : '--'}
        />

        <ResumeBox
          boxClassName="w-1/4"
          label="Tempo gasto em segundos"
          value={entry.result_data?.time_spent_in_seconds ? `${formatDecimal(entry.result_data.time_spent_in_seconds, 2)}s` : '--'}
        />

        <ResumeBox
          boxClassName="w-1/4"
          label="Média de tempo por linha"
          value={entry.result_data?.average_seconds_in_each_line ? `${formatDecimal(entry.result_data.average_seconds_in_each_line, 2)}s` : '--'}
        />
      </div>

      <div className="flex items-center gap-2">
        <ResumeBox
          boxClassName="w-1/4"
          label="Quantos foram processados"
          value={entry.result_data?.processed || '--'}
        />

        <ResumeBox
          boxClassName="w-1/4"
          valueClassName={entry.result_data?.success_count !== undefined ? 'text-valid' : ''}
          label="Número de sucessos"
          value={entry.result_data?.success_count !== undefined ? `${entry.result_data?.success_count || '0'}` : '--'}
        />

        <ResumeBox
          boxClassName="w-1/4"
          valueClassName={entry.result_data?.failure_count !== undefined ? 'text-danger-soft' : ''}
          label="Número de falhas"
          value={entry.result_data?.failure_count !== undefined ? `${entry.result_data?.failure_count || '0'}` : '--'}
        />

        <ResumeBox
          boxClassName="w-1/4"
          valueClassName={entry.result_data?.rollbacked !== undefined ? entry.result_data?.rollbacked ? `text-valid` : 'text-danger-soft' : ''}
          label="Linhas revertidas"
          value={entry.result_data?.rollbacked !== undefined ? entry.result_data?.rollbacked ? `Sim` : 'Não' : '--'}
        />
      </div>
    </div>
  );
};
